(function($){
  "use strict";

  const behaviorOptions = {
    name: 'izzyThemeDetector',
    selector: 'body',
  };

  function behavior(context, settings) {
    $(once(behaviorOptions.name, behaviorOptions.selector, context)).each(function(index, element) {
      $(function() {
        window.izzyThemeDetector = new IzzyThemeDetector();
      });
    });
  }

  Drupal.behaviors[behaviorOptions.name] = {
    attach: function(context, settings){
      behavior(context, settings);
    },
  }

  // Init self in case we are loaded async.
  if (jQuery.isReady) {
    // It is up to script to define scope and settings it should be applied to
    // in case of jquery mobile integration used you can use site_common.jquery_mobile.getPageContext()
    // to get only current page's context.
    // In this example we use global scope.
    const context = document;
    const settings = Drupal.settings;
    Drupal.behaviors[behaviorOptions.name].attach(context, settings);
  }

  class IzzyThemeDetector {
    constructor() {
      this._themes = {
        '/services/design': 'theme-a',
      };
      this.currentTheme = 'theme-default';
      this.pagePath = location.pathname.replace(/\/$/,"");
      this.init();
    }

    init() {
      for (let themePath in this._themes) {
        if (this.pagePath !== '' && this.pagePath.indexOf(themePath) >= 0) {
          this.currentTheme = this._themes[themePath];
          document.body.classList.add(this._themes[themePath]);
        }
      }
    }
  }
})(jQuery);
